export default {
	 addFirstElement (items, text = 'Seleccionar') {
		items.unshift({
			text,
			value: -1
		});
		return items;
	}
};


// WEBPACK FOOTER //
// ./src/helpers/dropdowns.js